import { Popover } from "antd-mobile"
import styled from "styled-components"

export const FavoriteMealDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  justify-content: space-between;
  padding: 0 var(--app-horizontal-padding);

  svg {
    cursor: pointer;
  }
`

export const FavoriteMealDetailsContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const FavoriteMealDetailsBody = styled.div`
  overflow-y: auto;
  height: calc(100% - var(--app-cta-height));
`

export const FoodImageBox = styled.div`
  height: 190px;
  width: 100%;
`
export const FoodImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

export const FavoriteMealDetailsInfo = styled.div`
  padding: var(--app-horizontal-padding);
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`

export const IngredientList = styled.div``

export const FoodImagePlaceholder = styled.img`
  width: 100%;
  height: 190px;
  object-fit: cover;
  position: absolute;
`

export const IngredientListTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  margin-bottom: 8px;
`
export const CtaMenuPopover = styled(Popover.Menu)`
  --arrow-size: 0px;

  .adm-popover-menu-list-inner {
    padding: 4px 0px;
  }

  .adm-popover-menu-item {
    svg {
      width: 16px;
      height: 16px;
    }

    padding-left: 0px;
    width: 173px;

    &:first-child {
      .adm-popover-menu-item-text {
        border-top: none;
      }
    }

    &:last-child {
      color: var(--Schemes-On-Error-Container, #ff4921);
    }

    .adm-popover-menu-item-text {
      padding: 8px 12px;
      line-height: 22px;
      font-weight: 600;
      font-size: 14px;
    }
  }
`

export const CtaOptionText = styled.span`
  line-height: 22px;
  font-weight: 400;
`
